import { ReactElement } from "react";
import Logomark from "../Logo/Logomark";
import User from "src/types/models/User";

interface IAvatar {
  src?: string;
  className?: string;
  wrapperClassName?: string;
  background?: string | null;
  isCompany?: boolean;
}

export function Avatar({ src, className = "", wrapperClassName = "" }: IAvatar): ReactElement {
  let image = (
    <img src={src} alt="avatar" className={`object-cover w-full h-full ${className || ""} `} />
  );

  //   If there is no src or the src comes from old website avatar numbers
  if (!src || src.length < 10) {
    wrapperClassName += " flex !bg-light-gray items-center justify-center ";
    image = <Logomark className={" !w-[30%] !h-[30%] !opacity-50 !grayscale"} />;
  }

  return (
    <div className={`w-full h-full rounded-full overflow-hidden ${wrapperClassName} `}>{image}</div>
  );
}

export function UserAvatar({ user, ...props }: IAvatar & { user?: User }) {
  return <Avatar src={user?.avatar} {...props} />;
}
